module.exports = __webpack_public_path__ + "banner-bg.4ff54186be6c042736136fafb3e757cf.jpg";